import { useContext, useEffect, useState } from "react";
import { Modal, Table } from "antd";
import { getPaymentStatusText, getProductTypeText, Order } from "@/common/constants/interfaces";
import { request } from "@/common/utils/utils";
import URLS from "@/common/constants/url";
import eventBus from "@/common/services/eventBus";
import CustomEvents from "@/common/constants/customEvents";
import { FileCenterContext, IFileCenterContext } from "@/common/components/FileCenterProvider";


function MyOrderModal() {
    const { userInfo } = useContext<IFileCenterContext>(FileCenterContext);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [orders, setOrders] = useState<Order[]>([])


    const updateOrders = async () => {
        if (!userInfo) {
            return
        }

        const data = await request<Order[]>({ url: URLS.GET_MY_ORDERS_PATH, method: 'GET' })
        setOrders(data)
    }

    useEffect(() => {
        updateOrders()
    }, [])

    useEffect(() => {
        eventBus.on(CustomEvents.OPEN_MY_ORDER_PANEL, () => {
            updateOrders()
            setIsModalOpen(true);
        })

        return () => {
            eventBus.off(CustomEvents.OPEN_MY_ORDER_PANEL, () => {
                setIsModalOpen(false);
            })
        }
    }, [])


    const handleModalClose = () => {
        setIsModalOpen(false)
    }

    const columns = [
        {
            title: '订单号',
            dataIndex: 'order_number',
            key: 'order_number',
        },
        {
            title: '周期',
            dataIndex: 'product_type',
            key: 'product_type',
            render: (text: any, order: Order) => getProductTypeText(order.product_type),
        },
        {
            title: '订单金额',
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: '订单状态',
            dataIndex: 'payment_status',
            key: 'payment_status',
            render: (text: any, order: Order) => getPaymentStatusText(order.payment_status),
        },
        {
            title: '创建时间',
            dataIndex: 'created_at',
            key: 'created_at',
        },
    ]

    return (
        <Modal
            title="我的订单"
            open={isModalOpen}
            onCancel={handleModalClose}
            width={1000}
        >

            <Table
                dataSource={orders}
                columns={columns}
                rowKey="id"
                pagination={{
                    pageSize: 20, // 默认每页展示10条记录
                    showSizeChanger: true, // 允许用户设置每页展示的记录数
                    pageSizeOptions: ['10', '20', '50', '100'], // 用户可以选择的每页展示记录数选项
                }}
            />
        </Modal>
    );
}

export default MyOrderModal